<template lang="pug">
  .table-responsive
    table#tbConsumibles.table.is-striped.is-fullwidth
      thead
        tr
          th Descripción
          th Cantidad en Almacenes
      tbody
        tr(v-for="(data, index) in consumibles" :key="index")
          td(v-if="data.subcategoria" @click="irConsumibleDetalle(data)")
            .control
              .tags.has-addons
                span.tag.is-black
                  i.fas.fa-tag
                  | &nbsp {{ data.categoria}}
                span.tag.is-warning {{ data.subcategoria}}
            .control
              .tags.has-addons
                span.tag.is-ligth
                  | Marca: {{ data.marca }}
                span.tag.is-light
                  | Modelo: {{ data.modelo}}
          td(v-else @click="irConsumibleDetalle(data)") 
            span.tag.is-black {{ data.categoria}}
            .control
              .tags.has-addons
                span.tag.is-ligth
                  | Marca: {{ data.marca }}
                span.tag.is-light
                  | Modelo: {{ data.modelo}}
          td
            .columns
              .column
                .field.is-grouped
                  .control(v-show="data.exist_EB04 > 0" @click="showModalConsumible(data, 'EB04')")
                    .tags.has-addons
                      span.tag EB04 GIA
                      span.tag(:class="checkAlmacen('EB04')") {{data.exist_EB04}}
                  .control(v-show="data.exist_TPA > 0" @click="showModalConsumible(data, 'TPA')")
                    .tags.has-addons
                      span.tag TPA GIA
                      span.tag(:class="checkAlmacen('TPA')") {{data.exist_TPA}}
                  .control(v-show="data.exist_CORPO > 0" @click="showModalConsumible(data, 'CORP')")
                    .tags.has-addons
                      span.tag CORPO GIA
                      span.tag(:class="checkAlmacen('CORP')") {{data.exist_CORPO}}
            .columns
              .column
                .field.is-grouped
                  .control(v-show="data.exist_IRGEc > 0" @click="showModalConsumible(data,'IRGEc')")
                    .tags.has-addons
                      span.tag IRGE
                      span.tag(:class="checkAlmacen('IRGEc')") {{data.exist_IRGEc}}
                  .control(v-show="data.exist_TPAc > 0" @click="showModalConsumible(data, 'TPAc')")
                    .tags.has-addons
                      span.tag TPA
                      span.tag(:class="checkAlmacen('TPAc')") {{data.exist_TPAc}}
                  .control(v-show="data.exist_CORPOc > 0" @click="showModalConsumible(data, 'CORPc')")
                    .tags.has-addons
                      span.tag CORPO
                      span.tag(:class="checkAlmacen('CORPc')") {{data.exist_CORPOc}}
                  .control(v-show="data.exist_EB00c > 0" @click="showModalConsumible(data, 'EB00c')")
                    .tags.has-addons
                      span.tag EB00
                      span.tag(:class="checkAlmacen('EB00c')") {{data.exist_EB00c}}
                  .control(v-show="data.exist_EB01c > 0" @click="showModalConsumible(data, 'EB01c')")
                    .tags.has-addons
                      span.tag EB01
                      span.tag(:class="checkAlmacen('EB01c')") {{data.exist_EB01c}}
                  .control(v-show="data.exist_EB02c > 0" @click="showModalConsumible(data, 'EB02c')")
                    .tags.has-addons
                      span.tag EB02
                      span.tag(:class="checkAlmacen('EB02c')") {{data.exist_EB02c}}
                  .control(v-show="data.exist_EB03c > 0" @click="showModalConsumible(data, 'EB03c')")
                    .tags.has-addons
                      span.tag EB03
                      span.tag(:class="checkAlmacen('EB03c')") {{data.exist_EB03c}}
                  .control(v-show="data.exist_EB04c > 0" @click="showModalConsumible(data, 'EB04c')")
                    .tags.has-addons
                      span.tag EB04
                      span.tag(:class="checkAlmacen('EB04c')") {{data.exist_EB04c}}
                  .control(v-show="data.exist_ERMc > 0" @click="showModalConsumible(data, 'ERMc')")
                    .tags.has-addons
                      span.tag ERM
                      span.tag(:class="checkAlmacen('ERMc')") {{data.exist_ERMc}}
              
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: 'TbConsumibles',
    props: {
      consumibles: {
        type: Array,
        default: []
      },
    },
    methods: {
      irConsumibleDetalle(consumible) {
        this.$store.commit('selectConsumible', consumible)
        this.$router.push('/Inventario/Consumibles/Detalle')
      },
      getOC_FC (art) {
        let texto = ''

        if (art.fechaCompra === '0000-00-00'){
          texto = `<span class="is-size-7"><b>O.C. </b> ${art.ordenCompra}
          <a class="button is-black is-rounded is-small">
            <i class="fas fa-history"></i>
          </a>
          </span>
          `
        } else {
          texto = `<span class="is-size-7"><b>O.C. </b> ${art.ordenCompra}</span>
            <span class="is-size-7">${art.fechaCompra}
              <a class="button is-black is-rounded is-small">
                <i class="fas fa-history"></i>
              </a>
            </span>
            `
        }
        return texto
      },

      verHistoria (id) {
        this.$router.push({ path: `/Inventario/Historia/${id}` } )
      },
      
      isSurtible (consumible) {
        let text = ''
        if (parseInt(consumible.cantidad) <= parseInt(consumible.limite)) {
          text = `<span class="tag is-danger">Es necesario surtir.</span>`
        } else {
          text = `<span class="tag is-light">Aun no es necesario surtir.</span>`
        }
        return text
      },

      checkAlmacen(ubi) {
        let clase = ''
        if (this.userLogin.ubicacion === ubi ) {
          clase = 'is-black'
        } else {
          clase = 'is-info'
        }
        return clase
      },

      showModalConsumible (cons,ubi) {
        cons['filter'] = ubi
        this.$emit('showModalConsumible', cons)
      }
    },
    computed: {
    ...mapState(['userLogin'])
    }
  }
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/TbConsumibles.vue